import localforage from 'localforage'

let localforageStoreRoomNames = localforage.createInstance({
  name: 'qm-survey-webapp',
  storeName: 'room-names'
})

const initialState = {
  all: [],
  roomName: {
    roomNameId: null,
    roomName: null
  }
}

let state = initialState

const getters = {
  getAllRoomNames: state => state.all
}

const actions = {
  importRoomNames ({ commit }, roomNames) {
    return new Promise((resolve, reject) => {
      commit('clearRoomNamesState')
      roomNames.forEach((roomName) => {
        let roomNameReformatted = {
          roomNameId: roomName.roomId,
          roomName: roomName.roomName
        }
        localforageStoreRoomNames.setItem(String(roomName.roomId), JSON.stringify(roomNameReformatted))
      })
      commit('setRoomNamesToState', roomNames)
      resolve()
    })
  },
  loadAllRoomNames ({ commit }) {
    return new Promise((resolve, reject) => {
      let roomNames = []
      localforageStoreRoomNames.iterate((value) => {
        roomNames.push(JSON.parse(value))
      }).then(() => {
        commit('setRoomNamesToState', roomNames)
        resolve()
      })
    })
  },
  clearRoomNameStorage ({ commit }) {
    return new Promise((resolve, reject) => {
      localforageStoreRoomNames.clear().then(() => {
        commit('clearRoomNamesState')
        resolve()
      })
    })
  }
}

// mutations
const mutations = {
  setRoomNamesToState (state, rooms) {
    state.all = rooms
  },
  clearRoomNamesState (state) {
    state = initialState
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}




// WEBPACK FOOTER //
// ./src/store/modules/roomNames.js